import { Intro } from "components/commons";
import locale from "localization";
import { generateReportAdmin, getCashIns } from "apis";
import { initialFilterState } from "./cashin-filter.state";
import CashInFilter from "./cashin-filter";
import CashInList from "./cashin-list";
import useDataTable from "hooks/useDataTable";
import { columns } from "./cashin-columns";
import { mapDataToList, mapFilterToRequest } from "./cashin.mapper";
import { useRouter } from "hooks";
import useExport from "hooks/useExport";
import { SuccessModal } from "components/modals";
import { useContext } from "react";
import { SessionContext } from "contexts";

const CashInModule = () => {
  const { sessionId } = useContext(SessionContext);
  const { location } = useRouter();

  const { filter, search, table } = useDataTable({
    api: {
      api: getCashIns,
      params: { platformType: "plc" },
    },
    filter: {
      initialState: initialFilterState({
        searchKey: location?.state?.searchKey,
        searchType: location?.state?.searchType ?? "cashinId",
      }),
      mapper: mapFilterToRequest,
    },
    table: { key: "cashins", mapper: mapDataToList, columns },
    searchKey: location?.state?.searchKey,
  });

  const exportReport = useExport({
    api: generateReportAdmin,
    hasModal: true,
    reportType: "cashin",
    mappedFilterState: {
      ...filter?.mappedFilterState,
      platformType: "plc",
      searchKey: search?.searchKey,
      sessionId,
    },
  });

  return (
    <div>
      <SuccessModal {...exportReport?.successModalComponent} />
      <div>
        <Intro title={locale.cashIn} subtitle={locale.viewTrackCashActivities} />
      </div>
      <CashInFilter {...filter} {...search} {...exportReport} />
      <CashInList table={table} />
    </div>
  );
};

export default CashInModule;
